window.projectFundingBodyChanged = () => {
  if ($("#project_funding_body").val() == "other") {
        $(".other-funding").show()
  } else {
        $(".other-funding").hide()
  }
}
